module.exports = __webpack_public_path__ + "img/book.d9d529b4.png";